import GooglePayButton from '@google-pay/button-react';
import { ComponentProps } from 'react';

export const googlePayButtonTypesArr = [
  'book',
  'buy',
  'checkout',
  'donate',
  'order',
  'pay',
  'plain',
  'subscribe',
] as const;

export type GooglePayButtonTypes = (typeof googlePayButtonTypesArr)[number];

export type TGooglePayAllowedCardNetworks = ComponentProps<typeof GooglePayButton>['paymentRequest']['allowedPaymentMethods'][0]['parameters']['allowedCardNetworks'];
